import handleActions from 'redux-actions/es/handleActions';
import { setPermission } from './actions';

const initialPermission = {
  console: false,
  productManagement: false
};

export default handleActions(
  {
    [setPermission.toString()]: (state, { payload: permission }) => {
      return {
        ...state,
        ...permission
      };
    }
  },
  initialPermission
);
